export default __webpack_public_path__ + "static/media/FoodStore_18.a41dea67.png";